import { PropertyStatus } from '@/types/index';

type BadgeVariant = 'success' | 'warning' | 'danger' | 'info' | 'default';

/**
 * Map PropertyStatus to Badge variant for color coding
 */
export function getStatusBadgeVariant(status: PropertyStatus): BadgeVariant {
  switch (status) {
    case PropertyStatus.FIRST_SELECTION:
      return 'info';        // Bleu - état initial
    case PropertyStatus.OPPORTUNITY:
      return 'success';     // Vert - opportunité à saisir
    case PropertyStatus.UNDER_ANALYSIS:
      return 'warning';     // Jaune - en cours d'étude
    case PropertyStatus.PURCHASED:
      return 'success';     // Vert - succès final
    case PropertyStatus.WITHDRAWN:
      return 'danger';      // Rouge - échec/abandon
    case PropertyStatus.REJECTED:
      return 'danger';      // Rouge - rejetée
    default:
      return 'default';     // Gris - fallback
  }
}

/**
 * Get French label for a PropertyStatus
 */
export function getStatusLabel(status: PropertyStatus): string {
  const labels: Record<PropertyStatus, string> = {
    [PropertyStatus.FIRST_SELECTION]: 'Première sélection',
    [PropertyStatus.OPPORTUNITY]: 'Opportunité',
    [PropertyStatus.UNDER_ANALYSIS]: 'Analyse en cours',
    [PropertyStatus.PURCHASED]: 'Achetée',
    [PropertyStatus.WITHDRAWN]: 'Retiré',
    [PropertyStatus.REJECTED]: 'Rejetée',
  };
  return labels[status] || status;
}
